import React, { useRef } from 'react'
import {
  TransitionGroup,
  Transition as ReactTransition,
} from 'react-transition-group'

const timeout = 350

const getTransitionStyles = {
  entering: { opacity: 0 },
  entered: { transition: `opacity ${timeout}ms ease-in-out`, opacity: 1 },
  exiting: { transition: `opacity ${timeout}ms ease-in-out`, opacity: 0 },
}

const TransitionChild = ({ children, ...rest }) => {
  const nodeRef = useRef(null)
  return (
    <ReactTransition
      {...rest}
      timeout={{ enter: timeout, exit: timeout }}
      nodeRef={nodeRef}
    >
      {(s) => (
        <div ref={nodeRef} style={{ ...getTransitionStyles[s] }}>
          {children}
        </div>
      )}
    </ReactTransition>
  )
}

const Transition = ({ children, location }) => (
  <TransitionGroup>
    <TransitionChild key={location.pathname}>{children}</TransitionChild>
  </TransitionGroup>
)

export default Transition
